export default __webpack_public_path__ + "static/notifications-presentation-by-c0a7b6622fb98a507a10ae5e137ecb63.png";